import { Button, Card } from 'ui';
import { useJoinOrganization } from '../../queries';

type P = {
  organizationId: string;
};

const OrganizationDetailJoinButton = ({ organizationId }: P) => {
  const { isPending: isJoiningOrganization, mutate: joinOrganization } = useJoinOrganization(organizationId);

  return (
    <Card>
      <Button
        block
        loading={isJoiningOrganization}
        onClick={() => {
          joinOrganization({ id: organizationId });
        }}
        size="large"
        type="primary"
      >
        Join Organization
      </Button>
    </Card>
  );
};

export default OrganizationDetailJoinButton;
